'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _magnificPopup = require('magnific-popup');

var _magnificPopup2 = _interopRequireDefault(_magnificPopup);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindUIActions = function bindUIActions() {
  var $nextButton = (0, _jquery2.default)('[data-product-image-next]');
  var $prevButton = (0, _jquery2.default)('[data-product-image-prev]');

  $nextButton.click(function () {
    var $active = (0, _jquery2.default)('[data-product-image]').filter('.active');
    var $next = $active.next('[data-product-image]');
    if ($next.length <= 0) {
      $next = $active.prev('[data-product-image]').first();
    }
    $active.removeClass('active').find('[data-product-image-wrapper]').addClass('hide');
    $next.addClass('active');
    $next.find('[data-product-image-wrapper]').removeClass('hide');
  });

  $prevButton.click(function () {
    var $active = (0, _jquery2.default)('[data-product-image]').filter('.active');
    var $prev = $active.prev('[data-product-image]');
    if ($prev.length <= 0) {
      $prev = $active.next('[data-product-image]').last();
    }
    $active.removeClass('active').find('[data-product-image-wrapper]').addClass('hide');
    $prev.addClass('active');
    $prev.find('[data-product-image-wrapper]').removeClass('hide');
  });
};

var init = exports.init = function init() {
  bindUIActions();
};